export default __webpack_public_path__ + "static/media/workspace.e1138710.svg";